import { pickStatisticsScopeFields } from '../../../filters/lib/statisticsFilterParams';
import { mapComparesForLens } from '../../../filters/lib/statisticsCompareHelpers';
import { resolveStatisticsPeriodDisplayLabel } from '../../../filters/lib/statisticsPeriodQuickPickUtils';
import {
	resolveCompositionChartConfigFromSnapshot,
	PERSISTED_CHART_KIND,
} from '../../board/lib/statisticsPersistedCharts';
import { filterOrdersForCompositionChart } from './compositionChartBuckets';
import { isCompositionChartPieLikeType, normalizeCompositionChartConfig } from './compositionChartConfig';
import {
	buildCompositionCompareSeriesList,
	buildCompositionCompareSeriesMatrix,
} from './buildCompositionCompareSeriesMatrix';

export const buildCompositionChartBundle = ({
	snapshot = null,
	filters = {},
	primaryPhaseStats = null,
	selectedPhase = null,
	isStatisticsQueryLoading = false,
}) => {
	const allOrders = primaryPhaseStats?.orders ?? [];
	const orders = filterOrdersForCompositionChart(allOrders, { selectedPhase });
	const chartConfig = resolveCompositionChartConfigFromSnapshot(snapshot);
	const scopeKey = JSON.stringify(pickStatisticsScopeFields(filters));
	const configKey = JSON.stringify(normalizeCompositionChartConfig(chartConfig));

	let compareSeriesMatrix = null;
	if (chartConfig.compareSeries && isCompositionChartPieLikeType(chartConfig.chartType)) {
		const compares = mapComparesForLens(primaryPhaseStats?.compares);
		const currentPeriod = primaryPhaseStats?.currentPeriod ?? null;
		const seriesList = buildCompositionCompareSeriesList({
			currentPeriod,
			currentPeriodLabel: resolveStatisticsPeriodDisplayLabel(filters.startDate, filters.endDate) || currentPeriod?.label || '',
			startDate: filters.startDate,
			endDate: filters.endDate,
			compares,
		});
		compareSeriesMatrix = buildCompositionCompareSeriesMatrix({
			orders: allOrders,
			seriesList,
			chartConfig,
			selectedPhase,
			filters,
		});
	}

	return {
		chartKind: PERSISTED_CHART_KIND.COMPOSITION,
		chartConfig,
		orders,
		primaryPhaseStats,
		compareSeriesMatrix,
		chartLoading: isStatisticsQueryLoading && !primaryPhaseStats,
		animationKey: `custom-${selectedPhase ?? 'all'}-${scopeKey}-${configKey}-${orders.length}-${compareSeriesMatrix?.series?.length ?? 0}`,
	};
};
